import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Spiner from '../../components/Spiner'
import FunctionsLogic from '../../functions/logic/FunctionsLogic'
import formValidation from '../../functions/validation/FormValidation'
import { useSnackbar } from 'notistack'
import Select from 'react-select'
import Dialog from '@mui/material/Dialog'
import './TestRequest.scss'
import Swal from 'sweetalert2'

const TRIAL_DAYS = 30

// Valores >= a este límite se consideran ilimitados en catalogo.plan_tier
const UNLIMITED = 9999

const toOptions = (data) =>
  (data || []).map((item) => ({ value: item.id, label: item.name }))

const escapeHtml = (text) =>
  String(text).replace(
    /[&<>"']/g,
    (char) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[
        char
      ]
  )

// Postgres devuelve booleanos como 't' / 'f'
const isTrue = (value) => value === true || value === 't' || value === 'true'

const formatLimit = (value, singular, plural, unlimited) => {
  const number = Number(value)
  if (number >= UNLIMITED) return unlimited
  return `${number} ${number === 1 ? singular : plural}`
}

// Agrupa los menús del plan por su menú padre (Mantenimiento, Operación...)
// respetando el orden en que vienen del API.
const groupFeatures = (features) => {
  const groups = []
  const byCode = {}

  features.forEach((feature) => {
    const code = feature.group_code || 'OTROS'

    if (!byCode[code]) {
      byCode[code] = { code, name: feature.group_name || 'Otros', items: [] }
      groups.push(byCode[code])
    }

    byCode[code].items.push(feature)
  })

  return groups
}

export default function TestRequest() {
  const [spiner, setSpiner] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [identificacion, setIdentificacion] = useState('')
  const [provincia, setProvincia] = useState([])
  const [tipoNegocio, setTipoNegocio] = useState([])
  const [arrayNegocio, setArrayNegocio] = useState([])
  const [canton, setCanton] = useState([])
  const [parroquia, setParroquia] = useState([])
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [dataAccepted, setDataAccepted] = useState(false)
  const [cedula, setCedula] = useState('')
  const [estab, setEstab] = useState('')
  const [razon, setRazon] = useState('')
  const [direccion, setDireccion] = useState('')
  const [phone, setPhone] = useState('')
  const [value, setValue] = useState('')
  const [email, setEmail] = useState('')
  const [tiers, setTiers] = useState([])
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [detailPlan, setDetailPlan] = useState(null)
  const [provinciaSelected, setProvinciaSelected] = useState(null)
  const [cantonSelected, setCantonSelected] = useState(null)
  const [parroquiaSelected, setParroquiaSelected] = useState(null)

  useEffect(() => {
    loadInitialData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadInitialData = async () => {
    setSpiner(true)

    const results = await Promise.all([
      getSelectsCbo(0, 'P'),
      getSelectsTipoNegocio(),
      getSelectTier()
    ])

    setSpiner(false)

    if (results.some((ok) => !ok)) {
      showMessage(global.GLOBAL_ERROR, global.GLOBAL_VARIANT)
    }
  }

  const getSelectTier = async () => {
    const response = await FunctionsLogic.getSelectTier()

    if (response.error) return false

    const rest = (response.data || []).filter(t => t.id === 'PLAN_REST')
    const others = (response.data || []).filter(t => t.id !== 'PLAN_REST')
    const data = [...others, ...rest]
    setTiers(data)
    setSelectedPlan(data[0]?.id ?? null)
    return true
  }

  const getSelectsTipoNegocio = async () => {
    const response = await FunctionsLogic.getSelectsTipoNegocio()

    if (response.error) return false

    setArrayNegocio(toOptions(response.data))
    return true
  }

  const getSelectsCbo = async (id, type) => {
    const response = await FunctionsLogic.getSelectsCboLogic(id, type)

    if (response.error) return false

    const options = toOptions(response.data)

    if (type === 'P') setProvincia(options)
    if (type === 'C') setCanton(options)
    if (type === 'PA') setParroquia(options)
    return true
  }

  const handleSelectChangeProvincia = (selectedOption) => {
    setProvinciaSelected(selectedOption)
    setCantonSelected(null)
    setParroquiaSelected(null)
    setCanton([])
    setParroquia([])
    getSelectsCbo(selectedOption.value, 'C')
  }

  const handleSelectChangeCanton = (selectedOption) => {
    setCantonSelected(selectedOption)
    setParroquiaSelected(null)
    setParroquia([])
    getSelectsCbo(selectedOption.value, 'PA')
  }

  const handleChangeNumber = (e, setState) => {
    const value = e.target.value
    const regex = /^[0-9]*$/

    if (regex.test(value)) {
      setState(value)
    }
  }

  // Permite tildes y ñ (José Muñoz)
  const handleChangeLetters = (e) => {
    const newValue = e.target.value
    const regex = /^[A-Za-zÀ-ÿ\s]*$/

    if (regex.test(newValue)) {
      setValue(newValue)
    }
  }

  const showMessage = (message, variant = 'warning') => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
  }

  const resetForm = () => {
    setEstab('')
    setIdentificacion('')
    setRazon('')
    setCedula('')
    setEmail('')
    setValue('')
    setDireccion('')
    setPhone('')
    setProvinciaSelected(null)
    setCantonSelected(null)
    setParroquiaSelected(null)
    setCanton([])
    setParroquia([])
    setTipoNegocio([])
    setTermsAccepted(false)
    setDataAccepted(false)
    setSelectedPlan(tiers[0]?.id ?? null)
  }

  const handledSend = async (event) => {
    event.preventDefault()

    const dataSave = {
      estab: estab.trim(),
      ruc: identificacion,
      razon: razon.trim(),
      cedula,
      email: email.trim(),
      name: value.trim(),
      dir: direccion.trim(),
      phone,
      provincia_id: provinciaSelected?.value,
      canton_id: cantonSelected?.value,
      parroquia_id: parroquiaSelected?.value,
      tipo_negocio: (tipoNegocio || []).map((item) => item.value),
      terms: termsAccepted,
      data: dataAccepted,
      plan: selectedPlan
    }

    // Se valida antes de la confirmación para no preguntar con datos incompletos
    const validation = formValidation.FormValidation(dataSave)

    if (validation.error) {
      showMessage(validation.message)
      return
    }

    const planName = tiers.find((tier) => tier.id === selectedPlan)?.name

    const result = await Swal.fire({
      title: '¿Desea solicitar la prueba gratuita?',
      html: `
        <div style="text-align:left">
          <p>
            Su información será registrada y validada por nuestro equipo.
          </p>
          <p>
            Una vez aprobada la solicitud, recibirá un correo electrónico
            con sus accesos al sistema.
          </p>
          <p>
            El periodo de prueba es de <b>${TRIAL_DAYS} días</b>.
          </p>
          ${
            planName
              ? `<p>Plan elegido para después de la prueba: <b>${escapeHtml(
                  planName
                )}</b>.</p>`
              : ''
          }
        </div>
      `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#198754',
      reverseButtons: true
    })

    if (!result.isConfirmed) {
      return
    }

    setSpiner(true)

    const response = await FunctionsLogic.saveRequestTestLogic(dataSave)

    setSpiner(false)

    if (response.error) {
      showMessage(response.message, response.variant || 'error')
      return
    }

    resetForm()

    Swal.fire({
      title: 'Solicitud enviada',
      text: 'Recibirá un correo cuando su acceso sea aprobado.',
      icon: 'success',
      confirmButtonColor: '#198754'
    })
  }

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '54px',
      borderRadius: '16px',
      border: state.isFocused ? '1px solid #198754' : '1px solid #d0d5dd',
      boxShadow: state.isFocused ? '0 0 0 .2rem rgba(25,135,84,.12)' : 'none',
      backgroundColor: 'rgba(255,255,255,.9)',
      transition: 'all .2s ease',
      cursor: 'pointer',

      '&:hover': {
        border: '1px solid #198754'
      }
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: '0 14px'
    }),

    placeholder: (provided) => ({
      ...provided,
      color: '#98a2b3',
      fontSize: '14px'
    }),

    singleValue: (provided) => ({
      ...provided,
      color: '#101828',
      fontWeight: 500
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: '16px',
      overflow: 'hidden',
      border: '1px solid #eaecf0',
      boxShadow: '0 12px 30px rgba(16,24,40,.12)',
      zIndex: 99
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#198754'
        : state.isFocused
        ? 'rgba(25,135,84,.08)'
        : '#fff',

      color: state.isSelected ? '#fff' : '#101828',
      padding: '14px 16px',
      cursor: 'pointer',
      fontSize: '14px'
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? '#198754' : '#667085',

      '&:hover': {
        color: '#198754'
      }
    }),

    indicatorSeparator: () => ({
      display: 'none'
    })
  }

  return (
    <>
      <Spiner opt={spiner} loadLabel={global.LOAD_LABEL_SEND} />

      <section className="trial-page">
        <div className="container">
          <div className="page-header-strip">
            <div className="page-header-left">
              <h1 className="hero-title">Administra reservas y espacios desde un solo lugar</h1>
              <p className="hero-subtitle">
                Gestiona horarios, clientes, reservas, pagos online y reportes
                operativos para canchas, coworkings, salas y espacios deportivos.
              </p>
            </div>

            <div className="trial-benefits-strip">
              <div className="free-trial-banner">
                <div className="free-trial-icon">
                  <i className="bi bi-gift-fill"></i>
                </div>
                <div className="free-trial-content">
                  <span>PRUEBA GRATUITA</span>
                  <h2>Comienza gratis</h2>
                  <p><strong className="trial-days-inline">{TRIAL_DAYS} días</strong> sin costo</p>
                </div>
              </div>

              <div className="feature-box"><i className="bi bi-calendar2-check"></i><span>Reservas online</span></div>
              <div className="feature-box"><i className="bi bi-grid-1x2"></i><span>Gestión de espacios</span></div>
              <div className="feature-box"><i className="bi bi-people"></i><span>Clientes</span></div>
              <div className="feature-box"><i className="bi bi-bar-chart"></i><span>Reportes</span></div>
              <div className="feature-box"><i className="bi bi-phone"></i><span>Multi dispositivo</span></div>
            </div>
          </div>

          <div className="request-plans-layout">
            <div className="request-card">
              <div className="request-card-left">
                <div className="request-mini-badge">Prueba gratuita</div>

                <h2>Todo listo para comenzar</h2>

                <p>
                  Centraliza la administración de tus espacios, reservas y
                  clientes en una sola plataforma moderna, rápida y accesible
                  desde cualquier dispositivo.
                </p>

                <div className="request-benefits">
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestión de reservas en tiempo real
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Administración de canchas y espacios
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Control de horarios y disponibilidad
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestión de clientes y usuarios
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Reportes operativos y métricas
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Acceso multiplataforma y multiusuario
                  </div>
                  <div>
                    <i className="bi bi-check-circle-fill"></i>
                    Configuración flexible según tu negocio
                  </div>
                </div>
              </div>

              <div className="request-card-right">
                <form noValidate onSubmit={(e) => handledSend(e)}>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <label htmlFor="tr-estab">Nombre comercial</label>
                      <input
                        id="tr-estab"
                        type="text"
                        className="form-control modern-input"
                        name="estab"
                        value={estab}
                        maxLength={150}
                        autoComplete="organization"
                        onChange={(e) => setEstab(e.target.value)}
                        placeholder="Arena Sports Center"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="tr-razon">Razón social</label>
                      <input
                        id="tr-razon"
                        type="text"
                        className="form-control modern-input"
                        name="razon"
                        value={razon}
                        maxLength={200}
                        onChange={(e) => setRazon(e.target.value)}
                        placeholder="Arena Sports S.A."
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-ruc">RUC</label>
                      <input
                        id="tr-ruc"
                        type="text"
                        inputMode="numeric"
                        className="form-control modern-input"
                        value={identificacion}
                        maxLength={13}
                        onChange={(e) =>
                          handleChangeNumber(e, setIdentificacion)
                        }
                        placeholder="13 dígitos"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-representante">Representante</label>
                      <input
                        id="tr-representante"
                        type="text"
                        className="form-control modern-input"
                        value={value}
                        maxLength={150}
                        autoComplete="name"
                        onChange={handleChangeLetters}
                        placeholder="Nombre y apellido"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-cedula">Cédula</label>
                      <input
                        id="tr-cedula"
                        type="text"
                        inputMode="numeric"
                        className="form-control modern-input"
                        value={cedula}
                        maxLength={10}
                        onChange={(e) => handleChangeNumber(e, setCedula)}
                        placeholder="10 dígitos"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="tr-email">Email</label>
                      <input
                        id="tr-email"
                        type="email"
                        className="form-control modern-input"
                        value={email}
                        maxLength={150}
                        autoComplete="email"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="correo@negocio.com"
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="tr-phone">Teléfono</label>
                      <input
                        id="tr-phone"
                        type="tel"
                        inputMode="numeric"
                        className="form-control modern-input"
                        value={phone}
                        maxLength={10}
                        autoComplete="tel"
                        onChange={(e) => handleChangeNumber(e, setPhone)}
                        placeholder="0991234567"
                      />
                    </div>

                    <div className="col-md-12">
                      <label htmlFor="tr-direccion">Dirección</label>
                      <input
                        id="tr-direccion"
                        type="text"
                        className="form-control modern-input"
                        value={direccion}
                        maxLength={300}
                        autoComplete="street-address"
                        onChange={(e) => setDireccion(e.target.value)}
                        placeholder="Calle principal, número y referencia"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-provincia">Provincia</label>
                      <Select
                        inputId="tr-provincia"
                        options={provincia}
                        value={provinciaSelected}
                        onChange={handleSelectChangeProvincia}
                        styles={customSelectStyles}
                        placeholder="Seleccione provincia"
                        noOptionsMessage={() => 'Sin resultados'}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-canton">Cantón</label>
                      <Select
                        inputId="tr-canton"
                        options={canton}
                        value={cantonSelected}
                        onChange={handleSelectChangeCanton}
                        styles={customSelectStyles}
                        placeholder={
                          provinciaSelected
                            ? 'Seleccione cantón'
                            : 'Primero elija provincia'
                        }
                        isDisabled={!provinciaSelected}
                        noOptionsMessage={() => 'Sin resultados'}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="tr-parroquia">Parroquia</label>
                      <Select
                        inputId="tr-parroquia"
                        options={parroquia}
                        value={parroquiaSelected}
                        onChange={(e) => setParroquiaSelected(e)}
                        styles={customSelectStyles}
                        placeholder={
                          cantonSelected
                            ? 'Seleccione parroquia'
                            : 'Primero elija cantón'
                        }
                        isDisabled={!cantonSelected}
                        noOptionsMessage={() => 'Sin resultados'}
                      />
                    </div>

                    <div className="col-md-12">
                      <label htmlFor="tr-tipo-negocio">Tipo de negocio</label>
                      <Select
                        inputId="tr-tipo-negocio"
                        isMulti
                        options={arrayNegocio}
                        styles={customSelectStyles}
                        value={tipoNegocio}
                        onChange={(e) => setTipoNegocio(e || [])}
                        placeholder="Seleccione uno o varios"
                        noOptionsMessage={() => 'Sin resultados'}
                      />
                    </div>

                    <div className="col-md-12">
                      <div className="modern-checks">
                        <div className="form-check">
                          <input
                            id="tr-terms"
                            type="checkbox"
                            className="form-check-input"
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="tr-terms">
                            Acepto los{' '}
                            <a
                              href={global.TERM_CONDITION}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              términos y condiciones
                            </a>
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            id="tr-data"
                            type="checkbox"
                            className="form-check-input"
                            checked={dataAccepted}
                            onChange={(e) => setDataAccepted(e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor="tr-data">
                            Autorizo el{' '}
                            <a
                              href={global.DIGITAL_DATA}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              tratamiento de mis datos
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="modern-actions">
                        <button
                          type="button"
                          className="btn btn-light modern-back-btn"
                          onClick={() => navigate('/')}
                        >
                          Regresar
                        </button>

                        <button
                          type="submit"
                          className="btn modern-submit-btn"
                          disabled={spiner}
                        >
                          Solicitar prueba gratuita
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <aside className="plans-side">
              <div className="plans-intro">
                <div className="plans-intro-badge">
                  <i className="bi bi-calendar2-check"></i>
                  Después de tu prueba
                </div>
                <h2>Elige tu plan</h2>
                <p>
                  Durante el mes de prueba tendrás <strong>acceso completo</strong>.
                  Al finalizar, solo las funciones del plan elegido estarán disponibles.
                </p>
              </div>

              <div className="modern-plans-grid">
                {tiers.map((tier) => {
                  const isActive = selectedPlan === tier.id
                  const isPopular = tier.id === 'PLAN02'
                  const isFree = Number(tier.price) === 0
                  const billingLabel = tier.id === 'PLAN_REST' ? '/mesa·mes' : '/mes'
                  const tierType = tier.id === 'PLAN_REST'
                    ? { label: 'Mesas · Restaurantes', icon: 'bi-shop' }
                    : { label: 'Espacios · Servicios', icon: 'bi-calendar2-check' }

                  return (
                    <div
                      key={tier.id}
                      className={`modern-tier-card${isActive ? ' active' : ''}`}
                      onClick={() => setSelectedPlan(tier.id)}
                    >
                      {/* Columna izquierda: nombre + precio */}
                      <div className="tier-col-price">
                        <span className="modern-tier-name">{tier.name}</span>
                        <div className="tier-price">
                          {isFree
                            ? <span className="tier-price-free">Gratis</span>
                            : <><span className="tier-price-amount">${Number(tier.price).toFixed(2)}</span><span className="tier-price-period">{billingLabel}</span></>
                          }
                        </div>
                        <span className="tier-type-tag"><i className={`bi ${tierType.icon}`}></i>{tierType.label}</span>
                      </div>

                      {/* Columna centro: features en píldoras */}
                      <div className="tier-pills">
                        <span><i className="bi bi-building"></i>{formatLimit(tier.max_locations, 'sucursal', 'sucursales', 'Sucursales ilimitadas')}</span>
                        <span><i className="bi bi-grid"></i>{formatLimit(tier.max_spaces, 'espacio', 'espacios', 'Espacios ilimitados')}</span>
                        <span><i className="bi bi-calendar-check"></i>Reservas online</span>
                        <span><i className="bi bi-list-check"></i>{(tier.features || []).length} funcionalidades</span>
                      </div>

                      {/* Columna derecha: acción + check */}
                      <div className="tier-col-action">
                        {isActive && <div className="modern-tier-selected"><i className="bi bi-check-lg"></i></div>}
                        <button
                          type="button"
                          className="modern-tier-detail-btn"
                          onClick={(e) => { e.stopPropagation(); setDetailPlan(tier) }}
                        >
                          Ver detalle
                        </button>
                      </div>
                    </div>
                  )
                })}
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Dialog
        open={Boolean(detailPlan)}
        onClose={() => setDetailPlan(null)}
        maxWidth="sm"
        fullWidth
        scroll="paper"
        PaperProps={{ className: 'plan-detail-modal' }}
      >
        {detailPlan && (
          <>
            <div className="plan-detail-header">
              <div>
                <span className="modern-tier-name">{detailPlan.name}</span>
                <h2 className="modern-tier-price">
                  ${Number(detailPlan.price).toFixed(2)}
                  <span>{detailPlan.id === 'PLAN_REST' ? '/reserva' : '/mes'}</span>
                </h2>
              </div>

              <button
                type="button"
                className="plan-detail-close"
                aria-label="Cerrar"
                onClick={() => setDetailPlan(null)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="plan-detail-body">
              {detailPlan.description && (
                <p className="plan-detail-description">
                  {detailPlan.description}
                </p>
              )}

              <div className="plan-detail-limits">
                <div>
                  <i className="bi bi-building"></i>
                  {formatLimit(
                    detailPlan.max_locations,
                    'sucursal',
                    'sucursales',
                    'Sucursales ilimitadas'
                  )}
                </div>

                <div>
                  <i className="bi bi-grid"></i>
                  {formatLimit(
                    detailPlan.max_spaces,
                    'espacio',
                    'espacios',
                    'Espacios ilimitados'
                  )}
                </div>

                {isTrue(detailPlan.online_pay) && (
                  <div>
                    <i className="bi bi-credit-card"></i>
                    Pagos online
                  </div>
                )}

                {isTrue(detailPlan.allow_additional) && (
                  <div>
                    <i className="bi bi-plus-circle"></i>
                    Servicios adicionales
                  </div>
                )}
              </div>

              {groupFeatures(detailPlan.features || []).map((group) => (
                <div key={group.code} className="plan-detail-group">
                  <strong>{group.name}</strong>
                  <ul>
                    {group.items.map((item) => (
                      <li key={item.code}>
                        <i className="bi bi-check-circle-fill"></i>
                        {item.name}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="plan-detail-footer">
              <button
                type="button"
                className="btn btn-light modern-back-btn"
                onClick={() => setDetailPlan(null)}
              >
                Cerrar
              </button>

              <button
                type="button"
                className="btn modern-submit-btn"
                onClick={() => {
                  setSelectedPlan(detailPlan.id)
                  setDetailPlan(null)
                }}
              >
                {selectedPlan === detailPlan.id
                  ? 'Plan seleccionado'
                  : 'Elegir este plan'}
              </button>
            </div>
          </>
        )}
      </Dialog>
    </>
  )
}
